import React from 'react';
import { LinkButton, Typography } from 'fronton-react';
import { addSlashToEndString, patchUrlByLocale } from 'utils';
import { CategoryItem } from './types';
import { AccordionList } from '../accordion-list';
import { ImagePlaceholder } from '../image-placeholder';
import { clickEvent } from '../utils';
import {
  category,
  categoryImage,
  categoryLabel,
  categoryLink,
  imageLink,
  subcategoryItem,
  subcategoryList,
} from './styles';

export const DATA_QA_CATEGORY_ITEM = 'category-item';

const ImageFallBack = () => <div className={categoryImage} />;

export const CategoriesItem: React.FC<CategoryItem> = ({
  titleImageRef,
  label: labelCategory,
  name: nameCategory,
  children,
  sitePath: categoryPath,
  renderCount,
  isFlexible: isCategoryFlexible,
  level: categoryLevel,
}) => {
  const href = patchUrlByLocale(addSlashToEndString(categoryPath));
  const finalCategoryName = labelCategory ?? nameCategory;
  return (
    <li className={category} data-qa={DATA_QA_CATEGORY_ITEM}>
      <a
        href={href}
        data-qa="link-wrapper"
        className={imageLink}
        onClick={() =>
          clickEvent(finalCategoryName, 'divisionPhotoLink', false, 0, isCategoryFlexible, categoryPath)
        }
      >
        <ImagePlaceholder
          src={titleImageRef}
          alt={finalCategoryName}
          className={categoryImage}
          fallback={<ImageFallBack />}
        />
      </a>
      <div>
        <a
          className={categoryLink}
          href={href}
          data-qa="subtitle"
          onClick={() =>
            clickEvent(finalCategoryName, 'divisionNameLink', false, 0, isCategoryFlexible, categoryPath)
          }
        >
          <Typography variant="l" size="subtitle" className={categoryLabel}>
            {finalCategoryName}
          </Typography>
        </a>
        <ul className={subcategoryList} data-qa="sub-list">
          <AccordionList category={finalCategoryName} renderCount={renderCount}>
            {children?.map(({ name, label, sitePath, isVisual, isFlexible: isSubcategoryFlexible }) => {
              const path = patchUrlByLocale(addSlashToEndString(sitePath));
              const subcategoryName = label ?? name;

              return isVisual ? (
                <li key={subcategoryName}>
                  <LinkButton
                    className={subcategoryItem}
                    href={path}
                    size="m"
                    onClick={() =>
                      clickEvent(
                        subcategoryName,
                        'subdivisionNameLink',
                        false,
                        categoryLevel,
                        isSubcategoryFlexible,
                        sitePath,
                      )
                    }
                  >
                    {subcategoryName}
                  </LinkButton>
                </li>
              ) : null;
            })}
          </AccordionList>
        </ul>
      </div>
    </li>
  );
};
